import React, { useContext, useEffect } from "react";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import DashboardLocations from "./DashboardLocations";
import { useRouter } from "./../util/router";
import { useAuth } from "./../util/auth";
import { SearchContext } from '../providers/SearchProvider';
import PricingSection from "./PricingSection";
import SearchedLocationList from "./SearchedLocationList";
import ExpandingSearchField from "./ExpandingSearchField";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import screenshotAdmin from '../assets/shownavAdminScreen.webp';
import { toast } from 'react-hot-toast';

function DashboardSection(props) {
  const auth = useAuth();
  const router = useRouter();
  const { searchFocused, searchText } = useContext(SearchContext);
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    if (router.query.paid && auth.user.planIsActive) {
      toast.success(`You are now subscribed to the ${auth.user.planId} plan!`);
    }
  }, [router.query.paid, auth.user.planIsActive, auth.user.planId]);

  return (
    <Section
    style={{ paddingTop: "30px" }}
    bgColor={props.bgColor}
      size={props.size}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
    >

      <Container>
        {auth.user.planId && <ExpandingSearchField />}
        <SectionHeader
          style={{minHeight: '50px'}}
          title={ searchFocused && isSmall ? '' : props.title}
          // subtitle={props.company}
          size={!isSmall ? 3 : 4}
          textAlign="center"
        />
      {auth.user.planId ? 
        <Grid container={true} spacing={10}>
          <Grid item={true} xs={12} >
            {!searchFocused && <DashboardLocations productionId={props.productionId} />}
            {searchFocused && <SearchedLocationList productionId={props.productionId} searchText={searchText} />}
          </Grid>
        </Grid> : <div style={{ position: 'relative', width: '100%', height: '800px' }}>
            {/* Background image layer */}
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundRepeat: 'no-repeat',
                backgroundImage: `url(${screenshotAdmin})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center -165px', // move image up by 500px
                opacity: 0.2,
                zIndex: 0,
                filter: 'blur(3px)',
              }}
            />

            {/* Foreground content */}
            <div style={{ position: 'relative', zIndex: 1 }}>
              <Typography align="center" style={{backgroundColor: '#151824ff', padding: 10}}>
                Your production has been created! You can edit your production information in your account settings. Click below to start your FREE 14 day trial of the full showNav locations dashboard. No credit card required.
              </Typography>
              <PricingSection />
            </div>
          </div>

        }
      </Container>
    </Section>
  );
}

export default DashboardSection;
